import PropTypes from 'prop-types';
import React from 'react';
import PanelLink from './PanelLink';
import * as Styled from './SlidingPanel.styled';

/**
 * PanelItem renders a block list item that aligns with
 * CSS styles for SlidingPanel
 *
 * It is mainly used in SlidingPanel to render links
 * to other SlidingPanels.
 */
const PanelItem = ({ children, forPanelId, onClick, ...props }) => (
  <PanelLink forPanelId={forPanelId} onClick={onClick}>
    <Styled.PanelItem as={forPanelId ? 'button' : 'p'} {...props}>
      {children}
      {forPanelId && <Styled.ItemIcon name="chevron-right" />}
    </Styled.PanelItem>
  </PanelLink>
);

PanelItem.propTypes = {
  /**
   * Child nodes
   */
  children: PropTypes.node.isRequired,
  /**
   * Panel ID the button is related to.
   * If specified, will be used for updating SlidingPanelsContext.
   */
  forPanelId: PropTypes.string,
  /**
   * Handler for click event
   */
  onClick: PropTypes.func
};

PanelItem.defaultProps = {
  forPanelId: null,
  onClick: null
};

export default PanelItem;
